import enterpriseClient from "./enterpriseClient";

/**
 * Sync created job opening with the Enterprise service.
 *
 * Endpoint:
 * POST /api/neoin/sync
 * Headers:
 * Authorization: Bearer <token>
 * Content-Type: application/json
 *
 * Body:
 * {
 *   "jobId": 386,
 *   "companyId": 515,
 *   "jobtype": "full-time/permanent"
 * }
 *
 * Note:
 * For job_openings -> requires company_id: cid (e.g. "CID1059")
 * For /sync API -> requires companyId: id (e.g. 515, the numeric entityId)
 *
 * @param {Object} payload
 * @param {number|string} payload.jobId - ID of the created job opening
 * @param {number|string} payload.companyId - Numeric entityId of the enterprise company
 * @param {string} [payload.jobtype] - Employment type (e.g. "full-time/permanent")
 * @param {string} [payload.emp_type] - Alternative field for employment type
 * @returns {Promise<any>} Server response from sync endpoint
 */
export const syncEnterpriseJobAPI = async (payload) => {
  if (
    !payload ||
    (!payload.jobId && !payload.id && !payload.job_id) ||
    (!payload.companyId && !payload.company_id && !payload.entityId)
  ) {
    console.warn("syncEnterpriseJobAPI: jobId and companyId are required", payload);
  }

  const rawJobId = payload?.jobId ?? payload?.id ?? payload?.job_id;
  const rawCompanyId = payload?.companyId ?? payload?.company_id ?? payload?.entityId;
  const rawJobType = payload?.jobtype || payload?.emp_type || "full-time/permanent";

  let jobtype = "full-time/permanent";
  if (typeof rawJobType === "string" && rawJobType.trim()) {
    jobtype = rawJobType.toLowerCase().replace(/\s*\/\s*/g, "/").trim();
  }

  const formattedPayload = {
    jobId: Number(rawJobId),
    companyId: Number(rawCompanyId),
    company_id: Number(rawCompanyId),
    jobtype,
  };

  try {
    const response = await enterpriseClient.post("/api/neoin/sync", formattedPayload);
    return response.data;
  } catch (error) {
    console.error("Error in syncEnterpriseJobAPI:", error);
    return Promise.reject(error?.response?.data || error);
  }
};

export const syncJobAPI = syncEnterpriseJobAPI;
export const syncEnterpriseJob = syncEnterpriseJobAPI;

export default syncEnterpriseJobAPI;

